import { graphql } from "../../generated"

export const GET_SINGLE_WELL = graphql(`
    query GetWell($wellInput: GetWellInput) {
        well(input: $wellInput) {
            ...WellIdentificationFields
        }
    }
`)
